import type { TVConfig } from '@nuxt/ui';
import type * as ui from '#build/ui';

export default {
    variants: {
        variant: {
            link: {
                trigger: 'px-0!',
                
                list: 'gap-10 px-0',
            }
        },
    },
    compoundVariants: [
        {
          orientation: 'horizontal',
          variant: 'link',
          class: {
            indicator: '-bottom-px h-[2px]'
          }
        },
    ]
} satisfies TVConfig<typeof ui>['tabs'];
